<template>
  <b-row style="padding: 12px 12px;">
    <b-col lg="3" sm="12" style="padding:0px !important">
      <vs-button @click="stockDetail(params.data)" radius size="small" icon="search" type="gradient"
        v-b-tooltip.hover.bottom="'Stok Detayı'"></vs-button>
    </b-col>
    <b-col lg="3" sm="12" style="padding:0px !important">
      <vs-button @click="recete(params.data.stokKodu)" color="success" radius size="small" icon="event_note"
        type="gradient" v-b-tooltip.hover.bottom="'Stok Reçetesi'"></vs-button>
    </b-col>
    <b-col lg="3" sm="12" style="padding:0px !important">
      <vs-button @click="getLogRecords(params.data.stokKodu)" color="danger" radius size="small" icon="assignment"
        type="gradient" v-b-tooltip.hover.bottom="'Stok Log Kayıtları'"></vs-button>
    </b-col>
    <b-col lg="3" sm="12" style="padding:0px !important">
      <vs-button @click="priceUpdate(params.data)" color="warning" radius size="small" icon="attach_money"
        type="gradient" v-b-tooltip.hover.bottom="'Fiyat Güncelle'"></vs-button>
    </b-col>
    <ReceteComponent ref="recetePopup" />
    <LogList :isAktiveLogList="isAktiveLogList" :module="'Stock'" ref="getLogList" />
  </b-row>
</template>

<script>
import LogList from "../../components/uzum-components/LogList.vue";
import ReceteComponent from "../../components/uzum-components/stoklistesi-components/ReceteComponent.vue";
export default {
  components: { ReceteComponent, LogList },
  data() {
    return { isAktiveLogList: false }
  },
  methods: {
    getLogRecords(stockNo){
      this.$refs.getLogList.getLogList(stockNo)
    },
    stockDetail(data) {
      this.$root.$emit("getStockListDetail", data);
    },
    priceUpdate(data) {
      this.$root.$emit("getStockPriceUpdate", data);
    },
    recete(skod) {
      //  alert(skod)
      this.$refs.recetePopup.receteDetay(skod);
    },
  }
};
</script>
